import actionTypes from "./GISAMIAR02ActionType";

/**
 * 実習結果取得
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: [],
};

/**
 * 実習結果を取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const trainingResults = (state = initialState, action) => {
    switch (action.type) {
        // 実習結果取得
        case actionTypes.GET_TRAINING_RESULTS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: [],
            });
        case actionTypes.GET_TRAINING_RESULTS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail,
            });
        case actionTypes.GET_TRAINING_RESULTS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: [],
            });
        case actionTypes.GET_TRAINING_RESULTS_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: [],
            });

        // 実習結果更新
        case actionTypes.UPDATE_TRAINING_RESULTS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: [],
            });
        case actionTypes.UPDATE_TRAINING_RESULTS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail,
            });
        case actionTypes.UPDATE_TRAINING_RESULTS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: [],
            });
        case actionTypes.UPDATE_TRAINING_RESULTS_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: [],
            });
        default:
            return state;
    }
};
